var _rect, _path, _path2, _path3, _ellipse, _ellipse2, _path4, _path5, _g, _path6, _path7, _ellipse3, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNoDataBuild = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 168,
    viewBox: "0 0 220 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 168,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.182 63.3223L167.668 80.4922V140.572L105.182 113.652V63.3223Z",
    fill: "#ABABAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.253 63.3809L54.2175 77.6421V140.773L105.253 113.448V63.3809Z",
    fill: "#BFBFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.122 136.268C124.02 132.14 99.2534 132.508 89.9524 108.383C81.4282 86.2717 112.873 64.9911 121.671 74.308C127.905 80.91 119.914 90.431 108.826 89.3614C96.3454 88.1575 88.9683 76.9962 91.4291 64.9911C96.3106 41.1774 133.841 25.4217 135.423 24.3242",
    stroke: "url(#paint0_linear_3787_76254)",
    strokeDasharray: "6 7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 133.617,
    cy: 10.9588,
    rx: 6.08118,
    ry: 8.00336,
    transform: "rotate(-45 133.617 10.9588)",
    fill: "#E0E0E1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 149.096,
    cy: 25.8615,
    rx: 6.08118,
    ry: 8.00336,
    transform: "rotate(135 149.096 25.8615)",
    fill: "#E0E0E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.365 20.6977C136.365 16.2242 139.991 12.5977 144.465 12.5977H146.869V14.9848C146.869 19.4583 143.242 23.0848 138.769 23.0848H136.365V20.6977Z",
    fill: "#ABABAB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3787_76254",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 12,
    width: 11,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.365 20.6977C136.365 16.2242 139.991 12.5977 144.465 12.5977H146.869V14.9848C146.869 19.4583 143.242 23.0848 138.769 23.0848H136.365V20.6977Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3787_76254)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.526,
    y: 15.5137,
    width: 1.6585,
    height: 12.143,
    transform: "rotate(-45 134.526 15.5137)",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.842 12.7548L139.015 11.582L147.601 20.1685L146.429 21.3412L137.842 12.7548Z",
    fill: "#E4E4E4"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.507 9.97023L156.542 9.01004",
    stroke: "#D9D9D9",
    strokeWidth: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.849 8.314L152.401 4.32031",
    stroke: "#D9D9D9",
    strokeWidth: 0.9
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.527,
    cy: 11.4938,
    rx: 4.42268,
    ry: 4.41565,
    fill: "#ABABAB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.216 77.7559L116.702 97.5847V167.605L54.216 140.685V77.7559Z",
    fill: "#DAE2EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.216 77.7559L116.702 97.5847V167.605L54.216 140.685V77.7559Z",
    fill: "url(#paint1_linear_3787_76254)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.982 80.4141L115.817 97.584V167.604L167.982 140.684V80.4141Z",
    fill: "#C5D0D9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.982 80.4141L115.817 97.584V167.604L167.982 140.684V80.4141Z",
    fill: "url(#paint2_linear_3787_76254)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.834 80.373L188 107.361L134.484 128.451L116 97.4516L167.834 80.373Z",
    fill: "#D3D3D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1416 77.6094L36.6748 104.857L98.2357 128.451L116.221 97.4144L54.1416 77.6094Z",
    fill: "#E0E0E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3787_76254",
    x1: 99.748,
    y1: 10.9703,
    x2: 55.6375,
    y2: 32.3494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3787_76254",
    x1: 85.4591,
    y1: 77.7559,
    x2: 85.4591,
    y2: 167.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0DFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3787_76254",
    x1: 141.899,
    y1: 80.4141,
    x2: 141.899,
    y2: 167.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNoDataBuild);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-no-data-build.704ac907c3f48b1a7e43e6621bc044eb.svg";